function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("style", {
  type: "text/css"
}, "\n\t.st0{fill:#8E384E;}\n");

var _ref3 = /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M325.8,54.3L224,156.1L122.2,54.3c-12.5-12.5-32.8-12.5-45.3,0L54.3,76.9c-12.5,12.5-12.5,32.8,0,45.3 L156.1,224L54.3,325.8c-12.5,12.5-12.5,32.8,0,45.3l22.6,22.6c12.5,12.5,32.8,12.5,45.3,0L224,291.9l101.8,101.8 c12.5,12.5,32.8,12.5,45.3,0l22.6-22.6c12.5-12.5,12.5-32.8,0-45.3L291.9,224l101.8-101.8c12.5-12.5,12.5-32.8,0-45.3l-22.6-22.6 C358.6,41.8,338.3,41.8,325.8,54.3z"
});

var SvgCancel = function SvgCancel(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Cancel_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 448 448",
    style: {
      enableBackground: "new 0 0 448 448"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCancel, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Cancel.578e2caa.svg";
export { ForwardRef as ReactComponent };